"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandCollapseComponent = void 0;
var app_1 = require("app");
var index_1 = require("../KeepTheRhythm/index");
var ExpandCollapseComponent = /** @class */ (function (_super) {
    __extends(ExpandCollapseComponent, _super);
    function ExpandCollapseComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selector = ".expand-collapse-elem";
        return _this;
    }
    ExpandCollapseComponent.prototype.BeforeInit = function () {
        var _this = this;
        this.$expandItem = this.$el.find(".expand-collapse-item");
        this.$expandItem.each(function (i, item) {
            _this.initItem(item);
        });
    };
    ExpandCollapseComponent.prototype.initItem = function (item) {
        var el = $(item);
        el.find(".item-title").click(function () {
            el.toggleClass("expand-collapse-item--opened");
            el.find(".item-content").slideToggle("slow", "swing", function () {
                if (el.find(".ktr").length) {
                    index_1.KTR.SetPendingUpdate();
                    app_1.ComponentService.UpdateComponentsSelector();
                }
            });
        });
    };
    return ExpandCollapseComponent;
}(app_1.Component));
exports.ExpandCollapseComponent = ExpandCollapseComponent;
var component = new ExpandCollapseComponent();
